import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 673CE0A7-8AA2-4BFD-9308-B51589FBF520
 * name sitemap
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sitemap.svg
 * tags
 */
export const SitemapIcon = createSvgIcon(<><path d="M9,2V8H11V11H5C3.89,11 3,11.89 3,13V16H1V22H7V16H5V13H11V16H9V22H15V16H13V13H19V16H17V22H23V16H21V13C21,11.89 20.11,11 19,11H13V8H15V2H9Z" /></>, 'SitemapIcon');
export default SitemapIcon